module.exports = __webpack_public_path__ + "media/images/icons/ic-arrow-left-f759faf3dc28a5e6265e7879eaa473b1.svg";